export default "__VITE_ASSET__5450841b__"